import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Input } from 'antd';
import './SlibarItem.less'
import restart from "assets/dashboard/xiugai.png"
import {
  dashboardApi,
  useSaveStationNameMutation 
} from "services/dashboardService" 
// import {useGetMenuQuery} from 'services/dashboardService'
import Notification from "common/components/NotificationMessage/Notification";

import {
  DashboardParams,
} from "services/utils/interfaces";
import { rootReducerType } from 'redux/combineReducers';

export default function SlibarItem(menuData: any) {
  const [slibarList, setSlibarList] = useState<any[]>([])
  const dispatch = useDispatch();
  let list: any[] = []
  // const { data: MenuData } = useGetMenuQuery(""); 

  const [saveStats, { isSuccess, data:saveData }] = useSaveStationNameMutation();

  const { stationId } = useSelector(
    (state: rootReducerType) => state.stationIdReducer
  );

  useEffect(() => {
    if (menuData.menuData) {
      dispatch({ type: 'SET_StationIndex', payload: 0 });
      dispatch({ type: 'SET_StationId', payload: "" });
      let dashboardMenu = menuData.menuData[0].Dashboard
      for (let i = 0; i < dashboardMenu.length; i++) {
        if (dashboardMenu[i] == "All") {
          list.push({
            stationId: "",
            text: "All Stations",
            active: true,
            isUpdate: false,
          })
        } else {
          list.push({
            stationId: dashboardMenu[i]['locationId.stationId'],
            text: dashboardMenu[i].stationName,
            active: false,
            isUpdate: false,
          })
        }
      }
    }

    setSlibarList(list)
  }, [menuData.menuData])

  useEffect(() => {
    if(slibarList) {
      slibarList.map((it, idx) => {
        if(it.stationId == stationId) {
          slibarTap(idx)
        }
      })
    }
  }, [stationId])

  useEffect(() => {
    if (isSuccess) {
      Notification({
				type: saveData?.success ? "success" : "warning",
				message: saveData?.success ? saveData?.message : "request fail",
        description: "",
      })
    }
  }, [isSuccess])

  const slibarTap = (index: number) => {
    const list = [...slibarList]
    list[index].active = true
    list.forEach((it, idx) => {
      if (index == idx) {
        dispatch({ type: 'SET_StationId', payload: it.stationId });
        dispatch({ type: 'SET_StationIndex', payload: stationId });
        it.active = true
      } else {
        it.active = false
      }
    })
    setSlibarList(list)
  }

  const restartTap = (index, item) => (e) => {
    setInputText(item.text)
    e.stopPropagation(); // 阻止事件冒泡
    let listArr: any[] = []
    listArr = slibarList.map((it, idx) => {
      if (idx == index) {
        it.isUpdate = true
      } else {
        it.isUpdate = false
      }
      return it
    })
    setSlibarList(listArr)
  }

  const params: DashboardParams = {
    specifyStationName: '',
    stationId: '',
  }

  const [inputText, setInputText] = useState("")

  const onChangerEnter = (index: number) => (e) => {
    setInputText(e.target.value)
  }

  const onPressEnter = (index: number) => (e) => {
    let listArr: any[] = []
    listArr = slibarList.map((it, idx) => {
      if (idx == index) {
        it.isUpdate = false
        params.specifyStationName = e.target.value
        params.stationId = it.stationId
        saveStats(params)
      } else {
        it.isUpdate = false
      }
      return it
    })
    setSlibarList(listArr)
  }

  const updateSlibarItem = (item, index) => {
    let listArr: any[] = []
    listArr = slibarList.map((it, idx) => {
      if (idx == index) {
        it.isUpdate = false
        params.specifyStationName = inputText
        params.stationId = it.stationId        
        saveStats(params)
      } else {
        it.isUpdate = false
      }
      return it
    })
    setSlibarList(listArr)
  }

  return (
    <div>
      <div className='slibar-son'>
        {slibarList.map((item, index) => {
          return (<div key={index} className={!item.active ? 'slibar-son-item' : 'slibar-son-item slibar-son-item-active'}
            onClick={() => slibarTap(index)}>
            {(item.isUpdate) ? <div className='slibar-item-input-box'>
              <Input defaultValue={item.text}
              onChange={onChangerEnter(index)}
              onPressEnter={onPressEnter(index)}
              onClick={(e) => e.stopPropagation()} placeholder="Update name" />
              <Button type='primary' style={{background:'#00cc43'}} onClick={() => {updateSlibarItem(item, index)}}>ok</Button>
            </div> : <div className='slibar-son-item-title'>
              <div className='slibar-son-item-title-text'>{item.text}</div>
              {item.stationId ? <img src={restart} alt="" onClick={restartTap(index, item)} /> : ""}
            </div>}
          </div>)
        })}
      </div>
    </div>
  )
}